<template>
    <div class="flex flex-col gap-4 p-6 rounded-xl">
        <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold text-gray-500">Linked Socials</h3>
        </div>

        <div v-show="ui.socials" class="flex flex-col gap-4">
            <div class="flex items-center gap-8 justify-start flex-wrap mt-12">
                <button id="google-btn"
                    class="wall_btn_ cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md relative">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/google.png" alt="Google" />
                    <span v-if="isGoogleConnected"
                        class="absolute top-0 right-0 bg-green-500 rounded-full w-5 h-5 flex items-center justify-center text-white text-sm">
                        ✓
                    </span>
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/linkedin.png" alt="LinkedIn" />
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/twitter.png" alt="Twitter" />
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/github.png" alt="GitHub" />
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/discord.png" alt="Discord" />
                </button>
            </div>

            <hr class="w-1/2 border border-gray-500 mt-6 mb-6" />

            <div v-if="isGoogleConnected" class="connect_info_container">
                <div class="flex items-center gap-4">
                    <img class="w-8 h-8 object-contain" src="@/assets/images/google.png" alt="Google" />
                    <div>
                        <p>Email Address</p>
                        <address>{{ email }}</address>
                    </div>
                </div>
                <div class="flex items-center gap-4 mt-4">
                    <button
                        class="text-red text-lg font-semibold w-1/2 hover:text-gray-300 border border-gray-500 px-4 py-4 cursor-pointer rounded-lg bg-transparent"
                        @click="disconnectGoogle">
                        Disconnect
                    </button>
                </div>
            </div>

            <hr class="w-1/2 border border-gray-500 mt-6 mb-6" />
        </div>
    </div>
</template>

<script>
import constants from '../../../../../constant';

export default {
    name: 'Socials',
    data() {
        return {
            ui: {
                socials: true,
            },
            email: '',
            isGoogleConnected: false,
            isRequestingAccounts: false,
        };
    },
    mounted() {
        // Initialize Google Sign-In
        if (window.google) {
            google.accounts.id.initialize({
                client_id: constants.googleLoginKey,
                callback: this.handleCredentialResponse,
                auto_select: false,
                ux_mode: 'popup',
            });

            // Render the real button
            google.accounts.id.renderButton(
                document.getElementById('google-btn'),
                {
                    theme: 'outline',
                    size: 'large',
                    type: 'icon',
                    width: 80
                }
            );
            // Check if Google is already connected
            this.checkGoogleConnection();
        }
    },
    methods: {
        async handleCredentialResponse(response) {
            const token = response.credential;
            const payload = { token };
            document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻 connecting with Google';
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            try {

                await this.$store.dispatch('auth/v2ConnectWithGoogle', payload).then((res) => {
                    console.log('Google connection response:', res);
                    this.isGoogleConnected = true;

                    this.$acl.change('user');
                    this.$vs.notify({
                        title: 'Google Connection',
                        text: 'Google account connected successfully!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success',
                    });
                });
            } catch (error) {
                const errorResponse = error.response?.data;
                let message = 'An error occurred while connecting to Google.';
                if (errorResponse?.errors?.email) {
                    message = 'Account does not exist!';
                } else if (errorResponse?.errors) {
                    message = typeof errorResponse.errors === 'string' ? errorResponse.errors : 'Connection failed.';
                }

                this.$vs.notify({
                    title: 'Google Connection',
                    text: message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            } finally {
                document.getElementById('loading-bg-transparent').style.display = 'none';
            }
        },
        async disconnectGoogle() {
            try {
                await this.$store.dispatch('auth/v2DisconnectGoogle');
                this.isGoogleConnected = false;
                this.email = '';
                localStorage.removeItem('googleConnected');
                localStorage.removeItem('googleEmail');

                this.$vs.notify({
                    title: 'Google Disconnected',
                    text: 'Google account has been disconnected.',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success',
                });
            } catch (error) {
                this.$vs.notify({
                    title: 'Google Disconnection',
                    text: 'Failed to disconnect Google account. Please try again.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            }
        },
        checkGoogleConnection() {
            const isConnected = localStorage.getItem('googleConnected');
            const storedEmail = localStorage.getItem('googleEmail');

            if (isConnected === 'true' && storedEmail) {
                this.isGoogleConnected = true;
                this.email = storedEmail;
            }
        },
    },
};
</script>

<style scoped>
.connect_info_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

address {
    font-style: normal;
    color: #a0aec0;
}
</style>